// Source of truth: RawHTMLDesign/PageCodeMapReadMe.md (Design Studio).
// Maps Design Studio page IDs → React routes. The PageLink in menu-config.json
// is converted to a React route by stripping the .html suffix and the leading "/".
//
// Conversion convention: Design Studio file path
//   "/brand-pull-order-management/pull-order-entry-&-status-page.html"
// becomes React route
//   "/brand-pull-order-management/pull-order-entry-status"
//
// Each design page becomes a React component co-located in
//   src/pages/<module-slug>/<page-slug>/<PageComponent>.jsx
// with sibling .css/.js files preserving the Design Studio asset layout.

export function designLinkToRoute(designPageLink) {
  if (!designPageLink) return '/';
  // Drop file extension and ampersands that are illegal in URL paths.
  return designPageLink
    .replace(/\.html$/i, '')
    .replace(/&/g, 'and')
    .replace(/\s+/g, '-')
    .toLowerCase();
}

// Page registry — keys are React route paths produced by designLinkToRoute().
// Lazy-imported in App.jsx so the route table only includes pages that have
// been converted from RawHTMLDesign so far.
export const PAGE_REGISTRY = {
  72447: {
    pageId: 72447,
    module: 'Brand Pull Order Management',
    designLink: '/brand-pull-order-management/pull-order-entry-&-status-page.html',
    route: '/brand-pull-order-management/pull-order-entry-and-status-page',
  },
  72448: {
    pageId: 72448,
    module: 'Production Schedule & Kitchen Slot Booking',
    designLink: '/production-schedule-&-kitchen-slot-booking/production-schedule-&-slot-calendar-page.html',
    route: '/production-schedule-and-kitchen-slot-booking/production-schedule-and-slot-calendar-page',
  },
  72449: {
    pageId: 72449,
    module: 'Brand Pull Order Management',
    designLink: '/brand-pull-order-management/consolidated-demand-dashboard-page.html',
    route: '/brand-pull-order-management/consolidated-demand-dashboard-page',
  },
  72450: {
    pageId: 72450,
    module: 'Raw Material Inventory',
    designLink: '/raw-material-inventory/raw-material-receipt-&-stock-ledger-page.html',
    route: '/raw-material-inventory/raw-material-receipt-and-stock-ledger-page',
  },
  72451: {
    pageId: 72451,
    module: 'Recipe & Bill of Materials Repository',
    designLink: '/recipe-&-bill-of-materials-repository/master-recipe-&-costed-bom-repository-page.html',
    route: '/recipe-and-bill-of-materials-repository/master-recipe-and-costed-bom-repository-page',
  },
  72452: {
    pageId: 72452,
    module: 'Transfer & Delivery Tracker',
    designLink: '/transfer-&-delivery-tracker/transfer-dispatch-&-receipt-page.html',
    route: '/transfer-and-delivery-tracker/transfer-dispatch-and-receipt-page',
  },
  72453: {
    pageId: 72453,
    module: 'Notifications & Audit',
    designLink: '/notifications-&-audit/inventory-alert-digest-settings-page.html',
    route: '/notifications-and-audit/inventory-alert-digest-settings-page',
  },
  72454: {
    pageId: 72454,
    module: 'System Administration & Master Data',
    designLink: '/system-administration-&-master-data/system-setup-&-master-data-page.html',
    route: '/system-administration-and-master-data/system-setup-and-master-data-page',
  },
  72455: {
    pageId: 72455,
    module: 'Recipe & Bill of Materials Repository',
    designLink: '/recipe-and-bill-of-materials-repository/brand-cost-allocation-report-page.html',
    route: '/recipe-and-bill-of-materials-repository/brand-cost-allocation-report-page',
  },
  72456: {
    pageId: 72456,
    module: 'Notifications & Audit',
    designLink: '/notifications-and-audit/system-activity-log-page.html',
    route: '/notifications-and-audit/system-activity-log-page',
  },
};
